module.exports = __webpack_public_path__ + "img/empty-content.970568c3.svg";